"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _GREGORIAN_FULL_DAY_NAME_OF_WEEK = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/constants/date/GREGORIAN_FULL_DAY_NAME_OF_WEEK"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Returns the corresponding Arabic full day name for
 * passed english day name eg: Monday to الاثنين
 * @param {string} enDayName
 * @returns {string}
 */
function getArabicFullDayNameOfWeek(enDayName) {
  var dayIndex = _GREGORIAN_FULL_DAY_NAME_OF_WEEK["default"].EN.indexOf(enDayName);
  return _GREGORIAN_FULL_DAY_NAME_OF_WEEK["default"].AR[dayIndex];
}
var _default = exports["default"] = getArabicFullDayNameOfWeek;